import React from 'react'
import './HeaderRow.css';

const HeaderRow = ({ img, dta, customer }) => {
    return (
        <div className='customer-details-header'>

            <div className='dp'>
                <img src={img} width="100%" />
            </div>


            <div className='data'>

                <div className='dt-1'>
                    <p className='label'>Number of Transaction</p>
                    <p className='val'>{customer !==null && customer.numberOfTransactionInThirtyDays}</p>
                    <p className='caption'>Number of transactions (30 days)</p>
                </div>

                <div className='dt-1'>
                    <p className='label'>Number of accounts</p>
                    <p className='val'>{customer !==null && customer.noOfBankAccount}</p>
                    <p className='caption'>These are number of accounts</p>
                </div>

                <div className='dt-3'>
                    <p className='label'>Status</p>
                    <p style={{marginTop:"5px"}}> {(dta.approved === 1) ?
                        <span className="approve" style={{ color: "green" }}><div className='bullet'></div>Approved</span> :
                        ((dta.approved === -1) ?
                            <span className="disapprove" style={{ color: "red" }}><div className='bullet'></div>Disapproved</span>
                            :
                            <span className='pending'>Pending</span>)}</p>
                </div>

            </div>

        </div>
    )
}

export default HeaderRow